import { gql, useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import SearchBar from "components/base/SearchBar";
import Spinner from "components/base/Spinner";
import { useState } from "react";
import { searchByProp } from "utils/search";
import { formatCountry } from "utils/string";

const FETCH_PRODUCTS_FOR_SALE = gql`
  query FETCH_PRODUCTS_FOR_SALE {
    products(
      productType: "normal"
      isSalable: true
      isActive: true
      hasOdooId: true
    ) {
      results {
        id
        odooId
        name
        number
        version
        countryCodeOfOrigin
        itemsPerSet
      }
    }
  }
`;

const ProductSelector = ({ onSelect, query = FETCH_PRODUCTS_FOR_SALE }) => {
  const [searchText, setSearchText] = useState("");
  const { loading, error, data } = useQuery(query);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <div className="flex flex-col flex-1 text-sm">
      <SearchBar
        bgColor="dark:bg-gray-900"
        autoFocus
        type="text"
        placeholder="Search by name or number"
        value={searchText}
        onChange={setSearchText}
      />

      <div className="mt-2 mx-1">
        {(data?.products.results || [])
          .filter((product) =>
            searchByProp(product, ["name", "number"], searchText),
          )
          .map((product) => (
            <div
              key={product.id}
              className="border-b dark:border-gray-700 hover:text-blue-600 dark:hover:text-blue-300 cursor-pointer py-2"
              onClick={() => onSelect?.(product)}
            >
              <div>
                <span className="font-semibold">
                  {product.number}
                  {product.version ? ` | v${product.version}` : ""}{" "}
                </span>{" "}
                <span>#OD:{product.odooId}</span>
              </div>
              <div className="opacity-70">
                {product.name}{" "}
                {product.countryCodeOfOrigin
                  ? `| ${formatCountry(product.countryCodeOfOrigin)}`
                  : ""}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ProductSelector;
